import { SaveIcon } from "allIcons";
import {
  BodyContainer,
  HeaderContainer,
  Loader,
  LoadingListCards,
  MainButton,
  PrimaryHeading,
  RightMainContainer,
  ToggleCard,
} from "commonUI";
import { parse } from "helpers";
import { usePages, useUpdatePagesSettings } from "hooks/pages";
import { t } from "i18next";
import { useEffect, useState } from "react";

export default function Pages() {
  const [inputValue, setInputValue] = useState({});
  const { data, isLoading, isRefetching } = usePages();
  const { mutate: updatePagesSettings, isLoading: updatingPagesSettings } =
    useUpdatePagesSettings();

  useEffect(() => {
    if (isLoading || isRefetching || !data) return;
    if (data) {
      const initialValues = {
        ...data,
        post_sync_settings: parse(data.post_sync_settings) || {},
      };
      setInputValue(initialValues);
    }
  }, [data, isLoading, isRefetching]);

  const handleSave = () => {
    updatePagesSettings(inputValue);
  };

  return (
    <>
      <RightMainContainer>
        <Loader show={updatingPagesSettings} loader="block" />
        <HeaderContainer>
          <PrimaryHeading className="leading-6">
            {t("siteSetting.pages.title")}
          </PrimaryHeading>
          <MainButton
            onClick={handleSave}
            disabled={updatingPagesSettings || isLoading || isRefetching}
          >
            <SaveIcon />
            {t("button.saveChanges")}
          </MainButton>
        </HeaderContainer>
        <BodyContainer>
          {isLoading ? (
            <LoadingListCards count={3} />
          ) : (
            Object.keys(inputValue?.post_sync_settings || {}).map((key) => {
              const setting = inputValue.post_sync_settings[key];
              return (
                <ToggleCard
                  key={key}
                  labelClass="!mt-0"
                  label={t("siteSetting.pages.module.title", {
                    module: setting.title_plural,
                  })}
                  description={t("siteSetting.pages.module.description", {
                    module: setting.title,
                  })}
                  value={setting?.value}
                  setValue={(checked) => {
                    setInputValue((prev) => ({
                      ...prev,
                      post_sync_settings: {
                        ...prev.post_sync_settings,
                        [key]: { ...setting, value: checked },
                      },
                    }));
                  }}
                />
              );
            })
          )}
          {/* <ToggleCard
            labelClass="!mt-0"
            label={t("siteSetting.pages.syncPages.title")}
            description={t("siteSetting.pages.syncPages.description")}
            disabled
          />
          <ToggleCard
            labelClass="!mt-0"
            label={t("siteSetting.pages.syncPosts.title")}
            description={t("siteSetting.pages.syncPosts.description")}
            disabled
          /> */}
        </BodyContainer>
      </RightMainContainer>
    </>
  );
}
